import { render, staticRenderFns } from "./AffiliateHeaderTestB.vue?vue&type=template&id=6a35e087&scoped=true"
import script from "./AffiliateHeaderTestB.vue?vue&type=script&lang=js"
export * from "./AffiliateHeaderTestB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a35e087",
  null
  
)

export default component.exports